import React, { Component } from 'react';
// import logo from './logo.svg';
import './css/App.css';
// import './components/utils/stepZilla/main.css';
// import StepZilla from './components/utils/stepZilla/main.js';
// import BecomeInvestor from './components/becomeInvestor/index';
// import BecomeInvestorAuthenticated from './components/becomeInvestorAuthenticated/index';
import BecomeApplicant from './components/becomeApplicant/index';
import LimitLoan from './components/limitLoan/index';
import InvoiceFinancing from './components/invoiceFinancing/index';
// import ChangePassword from './components/changePassword/index';
// import RegisterUser from './components/becomeApplicant/registerUser';
// import EnterNewPassword from './components/changePassword/EnterNewPassword'

// * import BorrowerPortal from './components/borrowerPortal/index';
// * import AdminPortal from './components/adminPortal/index';
// import InvestorApp from './components/investorApp/index';
// import Home from './components/investorApp/home/index';
// import Investments from './components/investorApp/investments';
// import Applications from './components/investorApp/applications';
// import Transactions from './components/investorApp/transactions';
// import Application from './components/investorApp/application';
// import Login from './components/login/login';
// asyncComponent from "./components/AsyncComponent";
// import User from './components/investorApp/user';
// * import MainPage from './components/mainPage/index';




import './css/bootstrap.min.css';
// import './components/utils/stepZilla/main.css';
import './css/site.css';

import { Route, BrowserRouter as Router, Switch } from 'react-router-dom'

// const googleAnalyticsDefaultConsentScript = `
//   gtag('consent', 'default', {
//     'ad_storage': 'denied',
//     'analytics_storage': 'denied',
//     'wait_for_update': 500,
//   });
// `;
// const googleScript = `
//   window.dataLayer = window.dataLayer || [];
//   function gtag(){dataLayer.push(arguments);}
//   ${googleAnalyticsDefaultConsentScript}
//   gtag('js', new Date());
// `;



class App extends Component {

  constructor(props) {
    super(props);
  }

  componentDidMount() {
    // GTM is already initialized in index.html
    
    // Clear localStorage when navigating to main application domain for fresh start
    if (window.location.hostname === 'online.kasvurahoitus.fi' || window.location.hostname === 'localhost') {
      localStorage.removeItem('Kasvurahoitus');
    }
  } 

  render() {
    // const AsyncAdminPortal = asyncComponent(() => import("./components/adminPortal/index"));
    // const AsyncBorrowerPortal = asyncComponent(() => import("./components/borrowerPortal/index"));


    return (
      <div className="App" style={{ height: "100% !important;" }}>

        <Router>
          <div style={{ height: "100% !important" }}>
            <Switch>
              {/* <Route exact path='/' component={MainPage}/> 
          <Route exact path='/invest' component={BecomeInvestor}/>
          <Route path='/authenticated/:number' component={BecomeInvestorAuthenticated}/>
          <Route path='/authenticationerror' component={BecomeInvestorAuthenticated}/>
          <Route path='/app' component={InvestorApp}/>                         
        
        */}
              <Route exact path='/limitloan' component={LimitLoan} />
              <Route exact path='/avaa-luottolimiitti' component={LimitLoan} />
              <Route exact path='/avaa-luottolimiitti/:id' component={LimitLoan} />
              <Route exact path='/laskurahoitus' component={InvoiceFinancing} />
              <Route exact path='/hae-laskurahoitusta' component={InvoiceFinancing} />
              <Route exact path='/hae-laskurahoitusta/:id' component={InvoiceFinancing} />
              <Route exact path='/' component={BecomeApplicant} />

              {/*
              <Route path='/login/:id' component={Login}/>               
              <Route path='/login' component={Login}/>               
              <Route path='/change-password' component={ChangePassword}/>               
              <Route path='/reset-password/:id' component={EnterNewPassword}/>               
              <Route exact path='/customer' component={AsyncBorrowerPortal}/>        
              <Route exact path='/admin' component={AsyncAdminPortal}/>        
              */}              

              <Route exact path='/:id' component={BecomeApplicant} />
              <Route exact path='/limitloan/:id' component={LimitLoan} />
              <Route exact path='/laskurahoitus/:id' component={InvoiceFinancing} />
              <Route exact path='/apply/:id' component={BecomeApplicant} />
              <Route exact path='/hae-yrityslainaa' component={BecomeApplicant} />
              <Route exact path='/hae-yrityslainaa/:id' component={BecomeApplicant} />


              <Route component={BecomeApplicant} />

              {/*
          <Route exact path='/register' component={RegisterUser}/>
          <Route exact path='/register/:id' component={RegisterUser}/>
          */}
            </Switch>
          </div>
        </Router>

      </div>

    );
  }
}

export default App;
